import {Component, Inject, inject, OnInit} from '@angular/core';
import {PermissionService} from '../../../../services/permission.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {CandidatService} from "../../../../services/candidat.service";
import {Candidat} from "../../../../models/Candidat";
import {AuthService} from "../../../../services/auth.service";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {SvgIconComponent} from "angular-svg-icon";
import {SharedModule} from "../../../../shared/shared.module";
import {FormBuilder, FormGroup} from "@angular/forms";
import {NgIf} from "@angular/common";
import {CoreModule} from "../../../core.module";
import {
  CanidateDocsComponent,
} from "../candidate-documents-dialog/documents-candidat.component";
import { MissionService } from '../../../../services/mission.service';
import { CandidatStatusOnMission } from '../../../../shared/utils/enums';

@Component({
  selector: 'app-candidate-details',
  templateUrl: './candidate-details.component.html',
  standalone: true,
  imports: [
    MatTabGroup,
    SvgIconComponent,
    MatTab,
    SharedModule,
    NgIf,
    CoreModule,
    CanidateDocsComponent
  ],
  styleUrl: './candidate-details.component.scss'
})
export class CandidateDetailsComponent implements OnInit {
  /** Onglets Documents / Planning conditionnés par DOCUMENT_EXPORT / PLANNING_VIEW (matrice client). */
  readonly permissions = inject(PermissionService);

  /** B1 (client clinique) : statut du pro (Vacataire / Titulaire / Remplaçant) — Vacataire par défaut. */
  proStatusLabel(value?: string | null): string {
    switch (value) {
      case 'TITULAIRE': return 'Titulaire';
      case 'REMPLACANT': return 'Remplaçant';
      default: return 'Vacataire';
    }
  }


  // Liste candidate
  calenderLoader = false;
  userId: any;
  randomData: any;
  user: any;
  events: any;
  disponibilityDays: any;

  candidat: Candidat
  loading = false;
  thirdStepForm: FormGroup = this.fb.group({
    nationality: [''],
    graduationYear :[''],
  });

  constructor(
    private candidatService: CandidatService,
    private auth: AuthService,
    private missionApi: MissionService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CandidateDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {


  }

  ngOnInit(): void {
    // this.getCandidatById()
    this.getCandidateDetailByIdEstaId()
    this.fetchMissionByCondidat();
    this.getDisponibility()
  }

  round(num: number) {
    return Math.round(num)
  }


  onDialogClose(): void {
    this.dialogRef.close();
  }
  getCandidatById() {
    this.candidatService.getCondidatById(this.data.candidature.candidatId).subscribe({
      next: data => {
        // this.candidat = data;
      }
    });
  }
  getEvaluationByCandidatId() {
     this.candidatService.getEvaluationByCandidatId(this.data.candidature.candidatId).subscribe({
       next: data => {
         this.candidat.ratingCount = data?.details?.length || 0;
      }
    });
  }
  getCandidateDetailByIdEstaId() {
    this.loading = true;
    this.candidatService.getCandidatDetailByIdEstaIdV2(this.data.candidature.candidatId, this.auth.id!).subscribe({
      next: data => {
        this.candidat = data;
        if (this.candidat?.birthDay)
        {
          this.candidat.age = this.calculateYears(this.candidat?.birthDay);
        }
        if (this.candidat?.graduationYear)
        {
          this.candidat.yearsOfExperiances = this.calculateYears(this.candidat?.graduationYear);
          this.candidat.graduationYear = this.getAccountCreationString(this.candidat.graduationYear);
        }
        if (this.candidat?.creationDate)
        {
          this.candidat.inscriptionYears = this.getAccountCreationString(this.candidat?.creationDate);
        }
        try {
          this.getEvaluationByCandidatId();
        } catch
        {

        }

        this.loading = false;
      }
    });
  }
//  getAccountCreationString(creationDate: string): string {
//     console.log(this.candidat);
//
//     const creation = new Date(creationDate);
//     const now = new Date();
//     const diffTime = now.getTime() - creation.getTime();
//     const diffDays = diffTime / (1000 * 60 * 60 * 24);
//
//     // Check if the account was created less than 30 days ago
//     if (diffDays < 30) {
//         // Check civility and return appropriate string
//         if (this.candidat?.civility.toLowerCase() === 'mr') {
//             return "Nouveau";
//         } else {
//             return "Nouvelle";
//         }
//     }
//
//     const month = creation.getUTCMonth() + 1; // Months are 0-based in JavaScript
//     const year = creation.getUTCFullYear();
//     const formattedMonth = month < 10 ? `0${month}` : month.toString();
//
//     return `Inscrit(e) sur la plateforme depuis : ${formattedMonth}-${year}`;
// }

  getAccountCreationString(creationDate: string): string {
    const creation = new Date(creationDate);
    const day = creation.getUTCDate();
    const month = creation.getUTCMonth() + 1;
    const year = creation.getUTCFullYear();
    const formattedDay = day < 10 ? `0${day}` : day.toString();
    const formattedMonth = month < 10 ? `0${month}` : month.toString();
    return `${formattedDay}-${formattedMonth}-${year}`;
  }

  calculateYears(date: string): number {
  const valueDate = new Date(date);
  const today = new Date();

  let age = today.getFullYear() - valueDate.getFullYear();
  const monthDifference = today.getMonth() - valueDate.getMonth();
  const dayDifference = today.getDate() - valueDate.getDate();

  // Adjust age if the current date is before the birthdate in the current year
  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--;
  }

  return age;
}

getDisponibility() {
  this.missionApi.addGetAvailability(this.data.candidature.candidatId).subscribe({
    next: ({ nonAvailabilityDates }) => {
      this.disponibilityDays = nonAvailabilityDates;
    },
    error: (err) => {
      console.log(err);
    },
  });
}

fetchMissionByCondidat() {
  this.calenderLoader = true;
  this.missionApi.getMissionsByCondidatV2(this.data.candidature.candidatId).subscribe({
    next: (res) => {
      this.events = res?.map((el: any, key: any) => {
        const diffDays = this.getDaysDifference(el?.startdate,el?.enddate,el?.starttime,el?.endtime);
        if (diffDays) {
          return {
            start: new Date(el.startdate),
            end: new Date(el.enddate),
            title: el?.missionTitle || 'Mission ' + el.id,
            etablissementNom: el?.etablissementNom,
            site: el?.adresseDto?.name,
            serviceAffectationsName: el?.serviceAffectationsName,
            user: this.user,
            color:
              el.statusOfCandidatOnMission ==
              CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH
                ? '#01a167'
                : '#FFC114',
            allDay: true,
            data: {
              ...el,
              user: {
                ...this.user,
                numsiret: res.numsiret,
                typeSecteur: el.typeSecteur,
              },
            },
          };
        } else {
          return {
            id: el?.id,
            start: new Date(el.startdate),
            end: new Date(el.startdate),
            title: el?.missionTitle || 'Mission ' + el.id,
            etablissementNom: el?.etablissementNom,
            site: el?.adresseDto?.name,
            serviceAffectationsName: el?.serviceAffectationsName,
            user: this.user,
            color:
              el.statusOfCandidatOnMission ==
              CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH
                ? '#01a167'
                : el.statusOfCandidatOnMission ==
                    CandidatStatusOnMission.REJECTED ||
                  el.statusOfCandidatOnMission ==
                    CandidatStatusOnMission.CANCELED_BY_CANDIDATE
                ? 'red'
                : '#FFC114',
            allDay: true,
            data: {
              ...el,
              user: {
                ...this.user,
                numsiret: res.numsiret,
                typeSecteur: el.typeSecteur,
              },
            },
          };
        }
      });
      this.randomData = res?.map((el: any) => {
        return {
          title: el?.missionTitle || 'Mission ' + el.id,
          secteur: el.typeSecteur || 'N/A',
          contractType:
            el?.typecontat == 'LIBERAL' ? 'INTÉRIM' : el?.typecontat,
          startDate: el.startdate,
          endDate: el.enddate,
          renumeration: el.compensationproposednet || 0,
          user: this.user,
          color:
            el.statusOfCandidatOnMission ==
            CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH
              ? '#01A167'
              : el.statusOfCandidatOnMission ==
                  CandidatStatusOnMission.REJECTED ||
                el.statusOfCandidatOnMission ==
                  CandidatStatusOnMission.CANCELED_BY_CANDIDATE
              ? 'red'
              : '#FFC114',
          candidatures: el.candidatures || 'N/A',
          currency: '$',
          status: el.statusOfCandidatOnMission,
        };
      });
      this.calenderLoader = false;
    },
    error: (err) => {
      console.log(err);
      this.calenderLoader = false;
    },
    complete: () => {},
  });
}

getDaysDifference(startDate: Date, endDate: Date, startTime: string, endTime: string): number {
  // Parse the startTime and endTime into hours and minutes
  const [startHour, startMinute] = startTime.split(':').map(Number);
  const [endHour, endMinute] = endTime.split(':').map(Number);

  // Set the time for startDate and endDate
  const startDateTime = new Date(startDate);
  startDateTime.setHours(startHour, startMinute, 0, 0);

  const endDateTime = new Date(endDate);
  endDateTime.setHours(endHour, endMinute, 0, 0);

  // Calculate the difference in full days and remaining hours
  const difference = endDateTime.getTime() - startDateTime.getTime();
  const fullDays = Math.floor(difference / (1000 * 60 * 60 * 24));
  const remainingHours = (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60);

  // Apply the rule: if there are any remaining hours, add an extra day
  const daysCount = remainingHours > 0 ? fullDays + 1 : fullDays;

  // Ensure at least 1 day is counted, if the difference is less than a day
  return daysCount === 0 ? 1 : daysCount;
}
}
